import { handleSelectProvider } from '../../modules/events/consultListeners';
import { appUrl, staffId } from '../../utils/variables';

export function loadProvidersDropdown(providers) {
    const wrapper = document.querySelector('.requestConsult__container .providersDropdown__wrapper');
    if (!wrapper) return;

    if(staffId) return;
    let list = document.querySelector(
        '.requestConsult__container .providersDropdown__wrapper .providers__select'
    );
    list.innerHTML = '';

    if (providers.length <= 0) {
        list.insertAdjacentHTML(
            'beforeend',
            `
            <li>No providers found</li>
        `
        );
    }

    for (const i of providers) {
        list.insertAdjacentHTML(
            'beforeend',
            `
        <li class="providersDropdown__option" 
            data-provider-id="${i.id}" 
            data-provider="${i.first_name + ' ' + i.last_name}"
            data-avt="${i?.photo ? i.photo : `${appUrl}/assets/images/png/default-avatar.png`}">
            
            <img src="${i?.photo ? i.photo : `${appUrl}/assets/images/png/default-avatar.png`}" />
            
            <div class="provider__info">
                <div>${i.first_name + ' ' + i.last_name}</div>
                ${i.title ? `<div class="providerDropdown__title">${i.title}</div>` : ''}
            </div>
        </li>
        `
        );
    }

    handleSelectProvider();
}
